export default {
  state: {
    isYoutubeLoaded: false,
    isLoginPopupVisible: false,
    loginReturnUrl: '',
    isShoppingPanelVisible: false
  }
}
